import { useEffect } from 'react'

export const useOnWindowFocusOrResume = (callback: () => void) => {
  useEffect(() => {
    const controller = new AbortController()
    const { signal } = controller

    const handleFocus = () => {
      if (document.visibilityState === 'visible') {
        callback()
      }
    }

    // Add event listeners for focus and visibility change
    window.addEventListener('focus', handleFocus, { signal })
    document.addEventListener('visibilitychange', handleFocus, { signal })

    // Cleanup event listeners on unmount
    return () => {
      controller.abort()
    }
  }, [callback])
}
